export default "__VITE_ASSET__BNq$pmEl__"